import React, { useMemo } from 'react';
import { Alert, Button, Card, Spin } from 'antd';
import { Elements } from '@stripe/react-stripe-js';
import { useNavigate } from 'react-router-dom';
import StripeCheckoutForm from './helpers/StripeCheckoutForm';
import { getStripePromise, stripeAppearance } from './helpers/stripe';
import { usePaymentIntentBootstrap } from './helpers/usePaymentIntentBootstrap';
import PayPalExpressButton from '../paypalExpressButton';
import './paymentForm.scss';

const PaymentForm: React.FC = () => {
  const { paymentData, loading, errorMessage } = usePaymentIntentBootstrap();
  const navigate = useNavigate();
  const stripePromise = useMemo(() => getStripePromise(), []);

  if (loading) {
    return (
      <div className="payment-loading" role="status" aria-live="polite" aria-label="Preparing secure payment form">
        <Spin size="large" aria-hidden="true" />
      </div>
    );
  }

  if (errorMessage || !paymentData || !stripePromise) {
    return (
      <Card title="Payment" className="payment-status-card">
        <Alert
          type="error"
          showIcon
          message="Checkout needs attention"
          description={errorMessage || 'Payment form is unavailable.'}
        />
        <Button
          className="payment-status-card__action"
          type="primary"
          onClick={() => navigate('/cart/checkout')}
        >
          Review Shipping
        </Button>
      </Card>
    );
  }

  return (
    <div className="payment-methods">
      <Elements
        key={paymentData.clientSecret}
        stripe={stripePromise}
        options={{
          clientSecret: paymentData.clientSecret,
          appearance: stripeAppearance,
        }}
      >
        <StripeCheckoutForm
          paymentIntentId={paymentData.paymentIntentId}
          paymentIntentClientSecret={paymentData.clientSecret}
        />
      </Elements>

      <div className="payment-info payment-info--paypal">
        <div className="payment-header">
          <div className="payment-copy">
            <h3 className="payment-title">PayPal Checkout</h3>
            <p className="payment-subtitle">
              Uses the delivery email and shipping address confirmed in the previous step.
            </p>
          </div>
        </div>
        <PayPalExpressButton />
      </div>
    </div>
  );
};

export default PaymentForm;
